import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import ExcelJS from "exceljs"
import { saveAs } from "file-saver";
import { useNavigate, useLocation } from "react-router-dom";
// import { getProductsData } from "../../../Services/productServices";
import moment from "moment";
import {
  lengthUnit,
  weightUnit,
currency_List 

} from "../../../Utils/Constant/MeasurementUnitList.jsx";
const priceData = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
const exportProductData = [
  { label: "CSV", value: "CSV" },
  { label: "PDF", value: "PDF" },
];

const ExportProduct = (props) => {
  const location = useLocation();
  const [productRecords, setProductRecords] = useState([]);
  const [parentRecords, setParentRecords] = useState(location.state?.productRecords);
  const [priceDetail, setPriceDetail] = useState(priceData[0].value);
  const [exportProductDetail, setexportProductDetail] = useState(
    exportProductData[1].value
  );
  const [fileName, setFileName] = useState(location.state?.fileName? location.state.fileName : "Product_Records");
  const history = useNavigate();

  useEffect(() => {
    if(!location?.state?.onBack){
      fetchProductRecords();
    } else{
      setProductRecords(parentRecords);
      setPriceDetail(location?.state?.priceColumn);
    }
  }, [parentRecords]);

  useEffect(()=> {
    if(productRecords?.length){
      if (!location?.state?.onBack) {
        if(exportProductData === "PDF"){
          history("../products-records/export-product/pdf", {
                state: {
                    body: location?.state?.body,
                    productRecords: productRecords,
                    rootPage: location?.state?.rootPage,
                    fileNameForPDF: fileName,
                    priceColumn: priceDetail,
                    exportProductDetail: exportProductDetail
                  },
          });
        }
        else
        {
          exportHandler();
        }
      }
  }
  },[productRecords]);

  const fetchProductRecords = async () => {
    try {
      if(parentRecords){
      const formattedRecords = parentRecords?.map((product) => {
        return {
          code: product.code,
          //created_at: moment(product.created_at).format("DD MMM YYYY"),
          name: product.name,
          grade: product.grade,
          gsm: product.gsm,
          burst_factor: product.burst_factor ? product.burst_factor : '',
          quality: product.quality,
          bulk: product.bulk,
          moisture : product.moisture? product.moisture : '',
          price: (currency_List.find((data) => data.code == product.units.price)).symbol + ' ' + parseFloat(product.price).toFixed(2) ,
          status: product.status === "active" ? "Active" : "Disabled",
          remarks: product.remarks,
          units : product.units
        };
      });
      setProductRecords(formattedRecords);
      setPriceDetail(location?.state?.priceColumn);
      setexportProductDetail(location?.state?.exportProductDetail);
    }
    } catch (err) {
      console.log("Error in fetching product records", err);
    }
  };
  const headers = priceDetail
    ? [
        { label: "PRODUCT CODE", key: "code" },
        { label: "PRODUCT NAME", key: "name" },
        { label: "GRADE", key: "grade" },
        { label: "GSM", key: "gsm" },
        { label: "BURST FACTOR", key: "burst_factor" },
        { label: "QUALITY", key: "quality" },
        { label: "BULK", key: "bulk" },
        { label: "MOISTURE", key: "moisture" },
        { label: "PRICE", key: "price" },
        { label: "STATUS", key: "status" },
        { label: "REMARKS", key: "remarks" },
      ]
    : [
        { label: "PRODUCT CODE", key: "code" },
        { label: "PRODUCT NAME", key: "name" },
        { label: "GRADE", key: "grade" },
        { label: "GSM", key: "gsm" },
        { label: "BURST FACTOR", key: "burst_factor" },
        { label: "QUALITY", key: "quality" },
        { label: "BULK", key: "bulk" },
        { label: "MOISTURE", key: "moisture" },
        { label: "STATUS", key: "status" },
        { label: "REMARKS", key: "remarks" },
      ];

  const priceStatusChange = (e) => {
    setPriceDetail(e.target.value);
  };
  const exportStatusChange = (e) => {
    setexportProductDetail(e.target.value);
  };
  const exportHandler = async() => {
    if(productRecords?.length){
      if(exportProductDetail === "CSV"){
        try{
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Product Records');

          worksheet.columns = headers.map((header)=>({
            header: header.label,
            key: header.key,
          }))

          const headRow = worksheet.getRow(1);

          headRow.eachCell((cell)=>{
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: {
                argb: "f3f4f6"
              }
            }
            cell.font = {
              bold: true,
            }
          })

          productRecords?.forEach((record)=>{
            const row = worksheet.addRow(record);
          })

          worksheet.columns.forEach((column)=>{
            let maxLength = 10;
            column.eachCell((cell)=>{
              let value = cell?.value?.toString() || "";
              maxLength = Math.max(maxLength,value?.length);
            })
            column.width = maxLength>50?50:maxLength+2;
          })

          const buffer = await workbook.xlsx.writeBuffer();
          saveAs(new Blob([buffer]),`${fileName}.xlsx`)
        }
        catch(e)
        {
          console.log(e);
        }
      } else {
        history("../products-records/export-product/pdf", {
                state: {
                    body: location?.state?.body,
                    productRecords: productRecords,
                    rootPage: location?.state?.rootPage,
                    fileNameForPDF: fileName,
                    exportProductDetail: exportProductDetail,
                    priceColumn: priceDetail
                  },
          });
      }
    } else{
      history("../products-records/preparing-export-products", {
        state: {
          body: location?.state?.body,
          rootPage: location?.state?.rootPage,
          fileName: fileName,
          headers: headers,
          priceColumn: priceDetail,
          exportProductDetail: exportProductDetail
        },
      });
    }
  };
  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => history("../products-records")}
          title="Export product records"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => history("../products-records")}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Select Options</h2>
                    <p>
                      Here you can select options to customize data that will be
                      downloaded
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Include Price</label>
                        <p>
                          Select yes if you want to include price details in
                          exported data
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={priceData}
                          onChange={priceStatusChange}
                          value={priceDetail}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Data Format</label>
                        <p>Select a format to download data</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={exportProductData}
                          onChange={exportStatusChange}
                          value={exportProductDetail? exportProductDetail : "PDF"}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="buttonRight" style={{ marginTop: "20px" }}>
                <Form.Item>
                  {!exportProductDetail || exportProductDetail === "PDF" ? (
                    <Button
                      onClick={() => exportHandler()}
                      className="themeBtn"
                    >
                      {" "}
                      Preview &#38; Download Records
                    </Button>
                  ) : (
                    // <Button
                    //   onClick={() => exportHandler()}
                    //   className="themeBtn csv"
                    // >
                    //   <CSVLink
                    //     data={productRecords}
                    //     headers={headers}
                    //     filename={fileName+".csv"}
                    //     target="_blank"
                    //   >
                    //     Download Product Records
                    //   </CSVLink>
                    // </Button>
                    <Button className="themeBtn csv"
                          onClick={() => exportHandler()}>
                            Download Product Records
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
    </RightLayoutContainer>
  );
};

export default ExportProduct;
